module.exports = {"id":"177134","name":"Demba Ba","rating":"77","photo":"./data/images/photos/1/177134.png","club":{"name":"Göztepe","logo":"./data/images/clubs/Goztepe.png"},"positions":["BU","AD","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DembaBa0.json
// module id = 1041
// module chunks = 0